
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUser, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { Actions } from '@/store/enums/StoreEnums';
import { MenuComponent } from '@/assets/ts/components';
import { resolveAvatarUrl } from '@/core/helpers/avatar';
import type { User } from '@/store/modules/AuthModule';

export default defineComponent({
  name: 'kt-user-menu',
  components: {
    FontAwesomeIcon,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const userDetail = computed<User>(() => store.getters.currentUser || ({} as User));

    const displayName = computed(() => userDetail.value.fullName || 'Người dùng');

    const avatarSrc = computed(() => resolveAvatarUrl(userDetail.value.avatar));

    const displayRole = computed(() => {
      const roles = userDetail.value.roles || [];
      if (!roles.length) {
        return '';
      }
      return roles.map((role) => role.name).filter(Boolean).join(', ');
    });

    const signOut = () => {
      // Overflow menus are moved to document.body; hide before leaving Layout
      // so the dropdown is not left visible on the sign-in page.
      MenuComponent.hideDropdowns(undefined);

      store
        .dispatch(Actions.LOGOUT)
        .then(() => router.push({ name: 'sign-in' }));
    };

    return {
      userDetail,
      displayName,
      avatarSrc,
      displayRole,
      signOut,
      faUser,
      faRightFromBracket,
    };
  },
});
